// extracted by mini-css-extract-plugin
module.exports = {"RecentlyPlayed":"RecentlyPlayed_RecentlyPlayed__2cHbf"};